export const databases = {start: 'start',  artpieces: 'artpieces', artists: 'artists', institutions: 'institutions', furtherInfo: 'furtherInfo', literature: 'literature', sources: 'sources'};


// WEBPACK FOOTER //
// ./src/localapi/databases.enum.js